import Vue from 'vue'

import Cookies from 'js-cookie'

import Element from 'element-ui'
import './assets/styles/element-variables.scss'

import '@/assets/styles/index.scss' // global css
import '@/assets/styles/ruoyi.scss' // ruoyi css
import '@/assets/styles/common.scss'
import App from './App'
import store from './store'
import router from './router'
import permission from './directive/permission'
import { download } from '@/utils/request'
import VueClipboard from 'vue-clipboard2'
import './assets/icons' // icon
import './permission' // permission control
import { getDicts } from '@/api/system/dict/data'
import { getConfigKey } from '@/api/system/config'
import { parseTime, resetForm, addDateRange, selectDictLabel, selectDictLabels, handleTree } from '@/utils/ruoyi'
import Pagination from '@/components/Pagination'
// 自定义表格工具扩展
import RightToolbar from '@/components/RightToolbar'
import uploader from 'vue-simple-uploader'

// 定义锚点跳转
Vue.use(uploader)
Vue.use(VueClipboard)


// 全局方法挂载
Vue.prototype.getDicts = getDicts
Vue.prototype.getConfigKey = getConfigKey
Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.addDateRange = addDateRange
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels
Vue.prototype.download = download
Vue.prototype.handleTree = handleTree

Vue.prototype.msgSuccess = function (msg) {
  this.$message({ showClose: true, message: msg, type: 'success' })
}

Vue.prototype.msgError = function (msg) {
  this.$message({ showClose: true, message: msg, type: 'error' })
}

Vue.prototype.msgInfo = function (msg) {
  this.$message.info(msg)
}

// 全局组件挂载
Vue.component('Pagination', Pagination)
Vue.component('RightToolbar', RightToolbar)

Vue.use(permission)

Element.Dialog.props.closeOnClickModal.default  =  false
/**
     * If you don't want to use mock-server
     * you want to use MockJs for mock api
     * you can execute: mockXHR()
     *
     * Currently MockJs will be used in the production environment,
     * please remove it before going online! ! !
     */

Vue.use(Element, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
})

Vue.config.productionTip = false

const app = new Vue({
  el: '#app',
  router,
  store,
  render: (h) => h(App),
})

// init footer and header
let LOADTEMP = initLoad('https://ecology.chinauos.com/adaptidentification/module@2024_4_23/')
LOADTEMP('uosdn-header', {
  active: '应用分发', // 选中标签栏
  user: '', // 可以不传,未登录传空，登录后传用户信息
  login: () => {
    // 设置用户信息（头像）
    menuTemp.setUser({
      photo: 'https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTLZCPzPsGheGIeP8e5y9b8NMnzHiaq9kjbuml3iaT7IClfpODIjTYeWey8hm4icicHRhuF1f07cBRaC5w/132',
    })
  },
  logout: () => {
    app.$confirm('确定注销并退出系统吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      app.$store.dispatch('LogOut').then((res) => {
        window.location.href = `${res.datas.account_logout_url}?callback=${res.datas.callback_url}`
      })
    })
  },
}, document.querySelector('#header-id')).then((menuTemp) => {
  // 侦听store中user信息变化，并设置头
  store.subscribe((mutation, state) => {
    if (mutation.type == 'SET_enterpriseName') {
      menuTemp.setUser({
        photo: state.user.avatar,
        user: state.user.enterpriseName,
      })
    }
  })
})
// //设置用户信息（头像）
// menuTemp.setUser({
//     photo: avatar
// })
LOADTEMP('chinauos-footer', { type: 'uosdn' }, document.querySelector('#footer-id'))
